export const TIPOS_DIRECCION = ['Particular', 'Laboral', 'Correspondencia'];

export const PAISES_RESIDENCIA = ['Chile', 'Argentina', 'Bolivia', 'Peru', 'Otro'];

export const NACIONALIDADES = ['Chilena', 'Extranjera'];

export const GENEROS_REGISTRALES = ['Femenino', 'Masculino', 'No informa'];

export const GENEROS_DECLARATIVOS = [
  'Femenino',
  'Masculino',
  'Transgenero',
  'Intergenero',
  'Otros',
  'No informa',
];

export const OPCIONES_CONYUGE = ['Si', 'No', 'Prefiero no declarar'];

/** Pueblos reconocidos en Chile (Ley 19.253 y reconocimientos posteriores). Catalogo ANID pendiente. */
export const PUEBLOS_ORIGINARIOS = [
  'Mapuche',
  'Aymara',
  'Rapa Nui',
  'Lican Antai',
  'Quechua',
  'Colla',
  'Diaguita',
  'Kawesqar',
  'Yagan',
  'Chango',
];

export const CANTIDAD_HIJOS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const REGIONES_CHILE = [
  'Arica y Parinacota',
  'Tarapaca',
  'Antofagasta',
  'Atacama',
  'Coquimbo',
  'Valparaiso',
  'Metropolitana',
  "O'Higgins",
  'Maule',
  'Nuble',
  'Biobio',
  'Araucania',
  'Los Rios',
  'Los Lagos',
  'Aysen',
  'Magallanes',
];

const COMUNAS_RM = [
  'Santiago',
  'Providencia',
  'Las Condes',
  'Nunoa',
  'Maipu',
  'Puente Alto',
  'La Florida',
  'Estacion Central',
];

export function comunasDeRegion(region: string): string[] {
  if (region === 'Metropolitana') return COMUNAS_RM;
  if (!region) return [];
  return ['Capital regional', 'Otra comuna'];
}
